/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconCalendar10 extends React.Component {
  render() {
    const iconClasses = classNames("icon calendar10", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M 6 4 C 4.895 4 4 4.895 4 6 L 4 24 C 4 25.105 4.895 26 6 26 L 24 26 C 25.105 26 26 25.105 26 24 L 26 6 C 26 4.895 25.105 4 24 4 L 6 4 z M 6 6 L 24 6 L 24 10 L 6 10 L 6 6 z M 18.1875 14.308594 C 19.9995 14.308594 21.146484 15.665766 21.146484 18.009766 C 21.146484 20.333766 20.0135 21.734375 18.1875 21.734375 C 16.3565 21.734375 15.228516 20.337906 15.228516 18.003906 C 15.228516 15.669906 16.3715 14.308594 18.1875 14.308594 z M 10.634766 14.496094 L 12.427734 14.496094 L 12.427734 21.542969 L 10.634766 21.542969 L 10.634766 16.113281 L 10.542969 16.113281 L 8.84375 17.259766 L 8.84375 15.716797 L 10.634766 14.496094 z M 18.1875 15.683594 C 17.5035 15.683594 17.050781 16.455906 17.050781 18.003906 C 17.050781 19.561906 17.5035 20.357422 18.1875 20.357422 C 18.8715 20.357422 19.330078 19.561906 19.330078 18.003906 C 19.330078 16.456906 18.8715 15.683594 18.1875 15.683594 z" />
      </svg>
    );
  }
}

IconCalendar10.defaultProps = {
  className: null
};

IconCalendar10.propTypes = {
  className: PropTypes.string
};

export default IconCalendar10;
